import * as React from "react"
import Link from "next/link"
import { cn } from "@repo/ui/utils"

import { AnimatedMarkup } from "./animated-markup"

export const createCustomComponents = ({ isStreaming = false }: { isStreaming: boolean }) => ({
  h1: ({ children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) => (
    <h1 {...props} className="!text-lg" style={{ overflowWrap: "anywhere" }}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </h1>
  ),
  h2: ({ children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) => (
    <h2 {...props} className="!text-lg" style={{ overflowWrap: "anywhere" }}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </h2>
  ),
  h3: ({ children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) => (
    <h3 {...props} style={{ overflowWrap: "anywhere" }} className="!text-base">
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </h3>
  ),
  h4: ({ children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) => (
    <h4 {...props} style={{ overflowWrap: "anywhere" }}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </h4>
  ),
  h5: ({ children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) => (
    <h5 {...props} style={{ overflowWrap: "anywhere" }}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </h5>
  ),
  h6: ({ children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) => (
    <h6 {...props} style={{ overflowWrap: "anywhere" }}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </h6>
  ),
  strong: ({ children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) => (
    <strong {...props}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </strong>
  ),
  a: ({ children, ...props }: React.HTMLAttributes<HTMLAnchorElement>) => (
    <a {...props} style={{ overflowWrap: "anywhere" }}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </a>
  ),
  p: ({ children, ...props }: React.HTMLAttributes<HTMLParagraphElement>) => (
    <p {...props} style={{ overflowWrap: "anywhere" }}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </p>
  ),
  small: ({ children, ...props }: React.HTMLAttributes<HTMLElement>) => (
    <small {...props}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </small>
  ),
  ul: ({
    ordered: _,
    ...props
  }: React.HTMLAttributes<HTMLUListElement> & { ordered?: boolean }) => (
    <ul {...props} className="leading-relaxed" />
  ),
  ol: ({
    ordered: _,
    ...props
  }: React.HTMLAttributes<HTMLOListElement> & { ordered?: boolean }) => (
    <ol {...props} className="leading-relaxed" />
  ),
  li: ({
    children,
    ordered: _,
    ...props
  }: React.HTMLAttributes<HTMLElement> & { ordered?: boolean }) => (
    <li {...props} className="leading-relaxed" style={{ overflowWrap: "anywhere" }}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </li>
  ),
  blockquote: ({ children, ...props }: React.HTMLAttributes<HTMLElement>) => (
    <blockquote {...props} className="max-w-full text-wrap" style={{ overflowWrap: "anywhere" }}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </blockquote>
  ),
  img: ({ alt, ...props }: React.ImgHTMLAttributes<HTMLImageElement>) => (
    <img alt={alt} {...props} />
  ),
  hr: ({ ...props }: React.HTMLAttributes<HTMLHRElement>) => <hr className="!my-8" {...props} />,
  table: ({ ...props }: React.HTMLAttributes<HTMLTableElement>) => (
    <div className="w-0 min-w-full overflow-x-auto">
      <table {...props} className="table-auto" />
    </div>
  ),
  tr: ({ ...props }: React.HTMLAttributes<HTMLTableRowElement>) => <tr {...props} />,
  th: ({ ...props }: React.HTMLAttributes<HTMLTableCellElement>) => (
    <th className="!min-w-48 break-words text-wrap" {...props} />
  ),
  td: ({ ...props }: React.HTMLAttributes<HTMLTableCellElement>) => (
    <td className="!min-w-48 break-words text-wrap" {...props} />
  ),
  code: ({ children, ...props }: React.HTMLAttributes<HTMLElement>) => (
    <code {...props} className="max-w-full text-wrap" style={{ overflowWrap: "anywhere" }}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </code>
  ),
  pre: ({ children, ...props }: React.HTMLAttributes<HTMLElement>) => (
    <pre {...props}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </pre>
  ),
  Link: ({ className, children, ...props }: React.ComponentProps<typeof Link>) => (
    <Link className={cn("font-medium underline underline-offset-4", className)} {...props}>
      <AnimatedMarkup isStreaming={isStreaming}>{children}</AnimatedMarkup>
    </Link>
  ),
  br: ({ ...props }: React.HTMLAttributes<HTMLBRElement>) => <br {...props} />
})
